export enum Keys {
  company = "company",
  trans = "all-trans",
  get_dial_codes = "get-dial-codes",

  home = "home",
  getAllProducts = "get-all-product",
  getCrossSellProducts = "get-cross-sell-products",
  searchProducts = "search-products",
  getProductDetails = "get-product-details",
  getFilters = "get-filters",
  get_cart = "get-cart",
  get_shipping_mthods = "get-shipping-mthods",
  get_payment = "get-payment",
  get_all_addresses = "get-all-addresses",

  get_all_applications = "get-all-applications",
  get_application_details = "get-application-details",
  get_all_application_types = "get_all_application_types",
  get_registerApplication = "get_registerApplication",

  get_search_biulder = "get-search-biulder",
  getAllApplications = "getAllApplications",

  get_all_appointments = "get-all-appointments",
  get_appointment_details = "get-appointment-details",
  profileQueryKey = "get-profile",
  get_address = "get-address",
  get_registration = "get-registration",
  get_cart_page_builder = "get-cart-page-builder",
  get_checkout_page_builder = "get-checkout-page-builder",
  get_address_page_builder = "get-address-page-builder",
  get_profile_page_builder = "get-profile-page-builder",
  get_student_builder = "get_student_builder",
  get_agent_form_builder = "get_agent_form_builder",
  get_application = "get_application_builder",

  query_get_all_categories_Key = "get-all-categories",
  query_get_category_details_Key = "get-all-categories",

  get_all_students = "get_all_students",
  get_all_agents = "get_all_agents",
  get_student_details = "get_student_details",
  getAllProgrammes = "getAllProgrammes",
  program_progress = "get-program_progress",
  export_program_progress = "export-get-program_progress",
  get_course_details = "get-course-details",
  getStudentPrograms = "get-student-programs",
  program_daily_log = "get-program-daily-log",
  get_process_by_time_report = "get_process_by_time_report",
  get_student_exams = "get_student_exams",

  get_all_consultations = "get-all-consultations",
  get_consultation_details = "get-consultations-details",
  get_consultation_replies = "get-consultations-replies",

  get_inner_page = "get-inner-page",

  get_all_orders = "get-all-orders",
  get_order_details = "get-order-details",

  get_time_slots = "get-time-slots",
  get_time_slots_specific = "get-time-slots-specific",
  get_pickup_mthods = "get-pickup-mthods",

  getAllBlogs = "get-all-blogs",
  getBlogDetails = "get-blog-details",
  GetBlogsCategories = "get-blogs-categories",

  getAllBlogComments = "get-all-blog-comments",
  getAllBlogCommentReplies = "get-all-blog-comment-replies",
  getBlogCommentLikeToggle = "get-blog-comment-like-toggle",
  getBlogCommentDislikeToggle = "get-blog-comment-dislike-toggle",
  getBlogLikeToggle = "get-blog-like-toggle",
  getAuthors = "get-authors",

  get_payment_mthods = "get_payment_mthods",
  user_locaion = "user_locaion",
  get_Delivery_branches = "get_Delivery_branches",
  currencies = "currencies",
  getProductSEOData = "get_product_seo_data",

  getAllProductReviews = "get_all_product_reviews",
  getToggleUsefulReview = "get_toggle_useful_review",
  getToggleUnusefulReview = "get_toggle_unuseful_review",
  getSitemap = "get_site_map",

  get_contact_us_page_builder = "get_contact_us_page_builder",

  query_get_all_brands_Key = "query_get_all_brands_Key",
  query_get_brand_details_Key = "query_get_brand_details_Key",
  global_cache_reset_timestamp = "global_cache_reset_timestamp",

  checkToken = "check_token",

  // Wallet
  get_wallet = "get_wallet",
  get_wallet_transactions = "get_wallet_transactions",
  get_returned_invoices = "get_returned_invoices",
  get_returned_invoice_details = "get_returned_invoice_details",
  get_exchange_invoices = "get_exchange_invoices",
  get_exchange_invoice_details = "get_exchange_invoice_details",

  // Try On Me
  try_on_me_status = "try_on_me_status",
  get_cities = "get_cities",
  get_areas = "get_areas",
}
